import ResourceStore from '../../services/ResourceStore';

class PayoutStore extends ResourceStore {
  _baseUrl (_params) {
    return '/api/v4';
  }
};

export default new PayoutStore('payout');
